import { IBusStopData } from "@/domain/entities/busStop";
import { BusStopMarker } from "@/types";
import { Ref, ref } from "vue";

interface UseBusStopMarkers {
  busStopMarkers: Ref<BusStopMarker[]>;
  getBusStopMarkerImage: () => any;
  createBusStopMarkers: (
    map: any,
    busStops?: IBusStopData[],
    selectedBusStopId?: string
  ) => void;
  removeBusStopMarkers: (busStops?: IBusStopData[]) => void;
  updateBusStopMarker: (selectedBusStopId?: string) => void;
}

export const useBusStopMarkers = (
  selectedBusStopMarker: Ref<any>,
  createMarker: (
    lat: number,
    lng: number,
    markerImage: () => any,
    zIndex: number
  ) => any,
  getSelectedBusStopMarkerImage: () => any,
  updateMarkerStyle: (
    marker: any,
    markerImage: () => any,
    zIndex: number
  ) => void,
  addMarkerClickEventListener: (marker: any, callBack: () => void) => void,
  removeMarkerClickEventListener: () => void,
  clickEventCallback: (busStopMarker: BusStopMarker) => void
): UseBusStopMarkers => {
  const busStopMarkers = ref<BusStopMarker[]>([]);

  const getBusStopMarkerImage = () => {
    return {
      url: require("@/assets/icons/marker.svg"),
      size: new window.naver.maps.Size(20, 20),
      origin: new window.naver.maps.Point(0, 0),
      anchor: new window.naver.maps.Point(10, 10),
    };
  };

  const createBusStopMarkers = (
    map: any,
    busStops?: IBusStopData[],
    selectedBusStopId?: string
  ) => {
    if (!busStops?.length) return;

    busStops.forEach((busStop) => {
      const isSelectedBusStop = busStop.id === selectedBusStopId;

      const marker = createMarker(
        busStop.latitude,
        busStop.longitude,
        isSelectedBusStop
          ? getSelectedBusStopMarkerImage
          : getBusStopMarkerImage,
        isSelectedBusStop ? 200 : 100
      );

      if (isSelectedBusStop) {
        selectedBusStopMarker.value = marker;
      }

      const busStopMarker: BusStopMarker = { busStop, marker };
      busStopMarkers.value.push(busStopMarker);
      addMarkerClickEventListener(busStopMarker.marker, () =>
        clickEventCallback(busStopMarker)
      );
      marker.setMap(map);
    });
  };

  const removeBusStopMarkers = (busStops?: IBusStopData[]) => {
    if (!busStops?.length) return;

    const targetMarkers = busStopMarkers.value.filter((marker) =>
      busStops.some((busStop) => busStop.id === marker.busStop.id)
    );

    targetMarkers.forEach((marker) => {
      removeMarkerClickEventListener();
      marker.marker.setMap(null);

      const index = busStopMarkers.value.indexOf(marker);
      if (index !== -1) {
        busStopMarkers.value.splice(index, 1);
      }
    });
  };

  const updateBusStopMarker = (selectedBusStopId?: string) => {
    busStopMarkers.value.forEach((busStopMaker) => {
      const marker = busStopMaker.marker;

      if (busStopMaker.busStop.id === selectedBusStopId) {
        updateMarkerStyle(marker, getSelectedBusStopMarkerImage, 200);
      } else {
        updateMarkerStyle(marker, getBusStopMarkerImage, 100);
      }
    });
  };

  return {
    busStopMarkers,
    getBusStopMarkerImage,
    createBusStopMarkers,
    removeBusStopMarkers,
    updateBusStopMarker,
  };
};
